var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShadow = function SvgShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 46,
    fill: "none",
    cursor: "pointer"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17B84E",
    d: "M177.655 46C201.041 46 220 28.772 220 7.52c0-2.574-.278-5.088-.808-7.52-3.848 17.653-20.982 30.962-41.537 30.962H42.345C21.79 30.962 4.655 17.652.808 0A35.3 35.3 0 0 0 0 7.52C0 28.771 18.959 46 42.345 46z"
  })));
};
export default SvgShadow;